import React, { Suspense, useCallback, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import {
  ActionHandlerMap,
  DomainSearchGateModule,
} from '@wix/domains-search-gate';
import { ProvidersWrapper } from '../../components/ProvidersWrapper';
import { HeaderAndFooterProvider } from '../../components/HeaderAndFooterProvider';
import { navigateToSplitPageStorefront } from '../../utils/storefrontNavigation';
import { NavigationService } from '../../utils/navigationService';
import '@wix/design-system/styles-odeditor.global.css';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { TSpecsExperiments } from '../../Specs';

const REFERRAL_ADDITIONAL_INFO = 'storefront_whois_results';

const basename = window.__BASE_URL__;
const experiments = window.__APP_PARAMS__.experiments
  ? (JSON.parse(window.__APP_PARAMS__.experiments) as TSpecsExperiments)
  : {};

export const WhoisResultsPageLoader = () => {
  return (
    <BrowserRouter basename={basename}>
      <Suspense fallback={<></>}>
        <ProvidersWrapper experiments={experiments}>
          <WhoisResultsPageWrapper />
        </ProvidersWrapper>
      </Suspense>
    </BrowserRouter>
  );
};

const WhoisResultsPageWrapper = () => {
  const { i18n } = usePremiumEssentialsContext();

  useEffect(() => {
    const pageUrl = window.location.href;

    HeaderAndFooterProvider({
      language: i18n.language ?? 'en',
      brand: 'wix',
      footer: true,
      stickyBehaviour: 'sticky',
      postLogin: pageUrl,
      postSignUp: pageUrl,
      postSignOut: pageUrl,
      header: true,
    });
  }, [i18n.language]);

  const purchaseHandler: ActionHandlerMap['purchase'] = useCallback(
    async ({ domainName }) => {
      navigateToSplitPageStorefront({
        domainName,
        referralAdditionalInfo: REFERRAL_ADDITIONAL_INFO,
      });
      // window.open returns synchronously; keep the promise pending so the
      // in-button loader stays visible until the browser unloads the page.
      await new Promise<never>(() => {});
    },
    [],
  );

  return (
    <DomainSearchGateModule.Provider translations={{ Loading: <></> }}>
      <DomainSearchGateModule.SDK.Pages.WhoisResultsPage
        handlers={{
          purchaseRootDomainIsRequired: purchaseHandler,
          purchase: purchaseHandler,
        }}
        onDomainNotFound={(domain) => {
          window.open(
            NavigationService.domainSearchResultsUrl({ query: domain }),
            '_self',
          );
        }}
      />
    </DomainSearchGateModule.Provider>
  );
};
